import config from '../../../config';

const paymentBaseUrl = `${config.apiUrl}/payments`;

type ExchangeCurrencyParams = {
  amount: number;
  amount_currency: string;
  requested_currency: string;
};

export default {
  createIntentUrl: () => `${paymentBaseUrl}/create_intent`,
  createSubscriptionUrl: () => `${paymentBaseUrl}/create_subscription`,
  completePaymentUrl: () => `${paymentBaseUrl}/complete`,
  updatePaymentIntentUrl: () => `${paymentBaseUrl}/update_intent`,
  exchangeCurrencyUrl: (amount: number, amountCurrency: string, requestedCurrency: string) =>
    `${paymentBaseUrl}/exchange_currency?amount=${amount}&amount_currency=${amountCurrency}&requested_currency=${requestedCurrency}`,
  multipleExchangeCurrencyUrl: (params: {
    tip: ExchangeCurrencyParams;
    sponsor_magazine: ExchangeCurrencyParams;
  }) =>
    `${paymentBaseUrl}/multiple_exchange_currency?currencies=${encodeURIComponent(
      JSON.stringify(params),
    )}`,
};
